import React from 'react';

import { observer } from 'mobx-react';

import { EntityModules } from 'core/constants';

import EntitySection from 'components/Entities/EntityDetailsTab/EntitySection';
import { BackgroundInformationSections } from 'components/Entities/EntityDetailsTab/styles';
import type { TabComponentProps } from 'components/Entities/EntityDetailsContent/types';

import { getFixedSection } from 'stores/EntityLayout/fixedSections';

const RiskDetailsTab: React.FunctionComponent<TabComponentProps> = ({ store }) => {
  const { details } = store;

  if (!details) {
    return <></>;
  }

  const scoringKey = getFixedSection(EntityModules.Risks)?.key;

  return (
    <BackgroundInformationSections>
      {details.layout.order
        .filter((key) => key !== scoringKey)
        .map((key) => {
          const section = details.layout.properties[key];
          if (!section) return null;
          return (
            <EntitySection key={key} sectionKey={key} title={section.title} fieldOrder={section.order} store={store} />
          );
        })}
    </BackgroundInformationSections>
  );
};

export default observer(RiskDetailsTab);
